import Bus from '../../bus'

import {
  logger,
  getUID
} from '../../utils'

import {
  NOTIFICATION_TYPE
} from '../../constants'

const createRemoveNotificationAction = (notificationIndex) => ({
  type: 'REMOVE',
  payload: notificationIndex
})

const createAddNotificationAction = (notification) => ({
  type: 'ADD',
  payload: notification
})

class NotificationService {
  __actionHandler = (action) => {
    Bus.send({
      event: Bus.events.notification.message,
      data: action
    })
  }

  notify (options) {
    const {
      title = 'Unknown Error Type',
      message,
      type = NOTIFICATION_TYPE.MESSAGE,
      status,
      data
    } = options

    const notificationId = this.createNotification({
      type,
      title,
      message,
      status,
      data
    })

    window.setTimeout(() => {
      this.removeNotification(notificationId)
    }, 4000)
  }

  display (options) {
    const {
      id,
      title = 'Notification',
      message = '',
      type = NOTIFICATION_TYPE.POPUP,
      status,
      data
    } = options

    const notificationId = this.createNotification({
      id,
      type,
      title,
      data,
      message,
      status
    })

    return notificationId
  }

  createNotification (options) {
    logger.debug('[notifications]', '✉️', 'new message', options)

    const id = options.id || getUID(10)

    const addAction = createAddNotificationAction({
      ...options,
      id
    })

    this.__actionHandler(addAction)

    return id
  }

  removeNotification (id) {
    const removeAction = createRemoveNotificationAction(id)
    this.__actionHandler(removeAction)

    return id
  }

  subscribe (handler) {
    // bus.addListener('notification:log')
    Bus.addListener(Bus.events.notification.message, handler)
    // this.__actionHandler = handler
  }

  unsubscribe (handler) {
    Bus.removeListener(Bus.events.notification.message, handler)
    // this.__actionHandler = null
  }
}

const $notifications = new NotificationService()

if (process.env.NODE_ENV === 'development') {
  window.$notifications = $notifications
}

export default $notifications
